import {Component} from '@angular/core';
import {AngularFireAuth} from "@angular/fire/auth";
import {Router} from "@angular/router";

@Component({
  selector: 'my-app',
  templateUrl: './app.component.html',
  styleUrls: [ './app.component.css' ]
})
export class AppComponent  {
    private logged: string;

  constructor(
      private afs:AngularFireAuth,
      private router:Router,
  ){

      this.afs.authState.subscribe(res => {


          if (res && res.uid) {
            this.logged = res.uid;
              this.router.navigate(['/']);


          }
      else {
              this.router.navigate(['/login']);


          }
      })
  }
}
